module.exports = __webpack_public_path__ + "static/media/image-slideshow-3x.7af2720a.png";